import { useContext } from 'react';
import { ConfigContext } from 'hooks/config/ConfigContext';

// ==============================|| CONFIG - HOOKS  ||============================== //

const useConfig = () => useContext(ConfigContext);

export default useConfig;
